import React, { Component } from 'react';
import SingleLineCaption from './dom-elements/SingleLineCaption';
import AnimateOnMount from './AnimateOnMount';

export default class ImageStack extends Component {
    constructor(props) {
        super(props);
        this.state = {
            topItem: 0,
            limit: 0,
            displayCaption: false,
            intervalId: null,
            images: this.props.imgs
        };
        this.addNextImage = this.addNextImage.bind(this);
        this.originalArrayLength = this.props.imgs.length;
        this.emptyImgObj = {
            urls: null,
            metadata: null
        };
    }

    renderImages() {
        return this.state.images.slice(0, this.state.limit).map((item, i) => {
            let bgStyle;
            if (item.urls != null) {
                 bgStyle = {
                    backgroundImage: 'url('+ item.urls.small +')'
                };                
            }
            return (
                <div className="image-stack-image" key={i}>
                    <AnimateOnMount>
                        {(item.urls != null ?
                            <div className="bg-image" style={bgStyle}></div>
                            :
                            <div></div>
                       )}
                    </AnimateOnMount>
                </div>
            );
        });
    }

    addNextImage() {
        let count;
        let item;
        let capt;
        let shifter;
        let blanksCount;
        if (this.state.limit < this.props.imgs.length) {
            count = this.state.limit + 1;
            item = this.state.limit;
            capt = this.props.imgs[item].metadata;
        } else {
            count = this.state.limit + 1;
            var oldOne = this.state.images[this.state.limit - this.originalArrayLength];
            var newOne = {
                urls: oldOne.urls,
                metadata: oldOne.metadata
            };
            capt = oldOne.metadata;
            this.state.images.push(newOne);
            oldOne.urls = null;
            oldOne.metadata = null;
            this.forceUpdate();
        }
 
        this.setState({
            limit: count,
            displayCaption: capt
        });
    }

    componentDidMount() {
        this.addNextImage();
        const intervalId = setInterval(this.addNextImage, 3000);
        this.setState({ intervalId: intervalId });
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }

    render() {
        return (
            <div className="image-stack-wrap">
                <div className="image-stack">
                    {
                        (this.state.displayCaption && (this.state.displayCaption.title != '')) ?
                            <div className="caption"> {                            
                                <SingleLineCaption Headline={this.state.displayCaption.title} Description={this.state.displayCaption.caption} Sep={true} />
                            } </div>
                            : null
                    }
                    <div className="image-stack-images">
                        {this.renderImages()}
                    </div>
                </div>
            </div>
        );
    }
};


// WEBPACK FOOTER //
// ./src/components/ImageStack.js